import _ from 'lodash';
import adapter from 'webrtc-adapter';
import "@/lib/gooroomee/webrtc/GrmWebRTC.adapter";
import {GrmEvent} from "@/lib/gooroomee/event/GrmEvent";
import { detect } from 'detect-browser';
import workletUrl from 'worklet-loader!./VolumeMeterProcessor.worklet'

const browser = detect();

const ChromeVersion = (function(){
    const version = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    return version ? parseInt(version[2], 10) : -1;
}());
const SAFARI = (function(){
    return navigator.userAgent.indexOf('hrome') == -1
        && (
            navigator.userAgent.indexOf('Safari/') != -1
            || navigator.userAgent.indexOf('Mac OS') != -1
        );
}());

let ID_NO = 0;
export class GrmWebRTC {
    static DefaultOptions = {

    };

    static async getUserDevice() {
        const result = {
            // videoinput: [],
            // audioinput: [],
            // audiooutput: []
        };

        // if(navigator.mediaDevices && navigator.mediaDevices.enumerateDevices){
            let devices = await navigator.mediaDevices.enumerateDevices();
            devices.forEach(device => {
                let list = result[device.kind] = result[device.kind] || [];
                list.push(device);
            });
        // }else{
        //
        // }

        return result;
    }

    static async getUserMedia(constraints) {
        // if(constraints.video || constraints.audio){
            return SR.request(async () => {
                let stream = await navigator.mediaDevices.getUserMedia(constraints);
                return stream;
            })
        // }
    }

    static attachMediaStream(element, stream) {
        if(!element || !stream){
            return;
        }
        if(element.innerHTML === undefined){
            if(element.$el){
                element = element.$el;
            }
        }

        element.setAttribute('data-grm-webrtc-streamId', stream.id);
        const trackIds = stream.getTracks().reduce(
            (id,track,i) => id+=`@${track.id}`
            , ''
        );
        element.setAttribute('data-grm-webrtc-trackIds', trackIds);

        element.srcObject = stream;
    }

    static getMediaSdpLine(media, sdp){
        let mMediaIdx = sdp.indexOf('m='+media);
        let str = sdp.substring(mMediaIdx, sdp.indexOf('\r\n', mMediaIdx));
        return str;
    }

    static parseBandwidth(sdp){
        const modifier = 'b=AS:';

        // if(firefox){
        //     modifier = 'b=TIAS:';
        // }

        function chkAsIndex(sdp, token){
            let tokenIndex = sdp.indexOf(token)
                ,n = -1;
            if(tokenIndex > 0){
                n = sdp.indexOf(modifier, tokenIndex);
            }
            return [tokenIndex, n];
        }
        function chkAs(sdp, offset){
            if(offset > 0){
                let as = sdp.substring(offset, sdp.indexOf('\r\n', offset))
                    .replace(modifier, '');
                return parseInt(as);
            }
            return 0;
        }

        let bw = {audio:0, video:0}
            ,nAudio = chkAsIndex(sdp, 'm=audio')
            ,nVideo = chkAsIndex(sdp, 'm=video')
            ,nApp = chkAsIndex(sdp, 'm=application')
        ;

        if(nAudio[0] < nVideo[0]){
            if(nAudio[1] > nVideo[0]){
                nAudio[1] = -1;
            }
        }else{
            if(nVideo[1] > nAudio[0]){
                nVideo[1] = -1;
            }
        }

        if(nAudio[0] < nApp[0]){
            if(nAudio[1] > nApp[0]){
                nAudio[1] = -1;
            }
        }else{
            if(nApp[1] > nAudio[0]){
                nApp[1] = -1;
            }
        }

        if(nVideo[0] < nApp[0]){
            if(nVideo[1] > nApp[0]){
                nVideo[1] = -1;
            }
        }else{
            if(nApp[1] > nVideo[0]){
                nApp[1] = -1;
            }
        }

        bw.audio = chkAs(sdp, nAudio[1]);
        bw.video = chkAs(sdp, nVideo[1]);

        return bw;
    }

    // static setBandWidth(sdp, p_bw){
    //     const modifier = 'b=AS';
    //     let bw = {
    //         audio: Object.assign(p_bw.audio),
    //         video: Object.assign(p_bw.video),
    //     };
    //     // if(firefox){
    //     //     bw.audio *= 1000;
    //     //     bw.video *= 1000;
    //     //     modifier = 'b=TIAS';
    //     // }
    //
    //     let mAudioIdx = sdp.indexOf('m=audio')
    //         ,mVideoIdx = sdp.indexOf('m=video');
    //
    //     let videoLineList = this.getMediaSdpLine('video', sdp).split(' ');
    //     let codecNo = videoLineList[3];
    //
    //     sdp = sdp.replace(new RegExp(modifier+'([^\r\n]+\r\n)', 'g'), '');
    //
    //     function isAuto(b) {
    //         return !b || b === -1 || b === 'auto';
    //     }
    //
    //     if(isAuto(bw.audio)){
    //         bw.audio = null;
    //     }
    //     if(isAuto(bw.video)){
    //         bw.video = null;
    //     }
    //
    //     if(bw.audio){
    //         if(bw.audio > 80){
    //             console.warn('max send bandwidth for audio content :', bw.audio);
    //             bw.audio = 80;
    //         }
    //         sdp = sdp.replace(/a=mid:audio\r\n/g, 'a=mid:audio\r\n'+modifier+':'+bw.audio+'\r\n');
    //     }
    //
    //     let min_bitrate, max_bitrate;
    //     if(bw.video){
    //         max_bitrate = bw.video;
    //         min_bitrate = max_bitrate
    //         sdp = sdp.replace(/a=mid:video\r\n/g, 'a=mid:video\r\n'+modifier+':'+bw.video+'\r\n');
    //     }
    //
    //     (bw => {
    //         if(!bw.video){
    //             return;
    //         }
    //
    //         if(min_bitrate){
    //             sdp = sdp.replace(
    //                 new RegExp('a=rtpmap:'+codecNo+' VP8/90000\r\n', 'g'),
    //                 `a=rtpmap:${codecNo} VP8/90000\r\n`
    //                 + `a=fmtp:${codecNo} x-google-start-bitrate=${min_bitrate}; x-google-min-bitrate=${min_bitrate}`
    //                 + (max_bitrate ? `; x-google-max-bitrate=${max_bitrate}` : '')
    //                 + '\r\n'
    //             );
    //         }
    //     })(bw);
    //
    //     return sdp;
    // }

    static stopMediaStreamVideoTracks(stream) {
        if(!stream){
            return;
        }
        stream.getVideoTracks().forEach(function(track){
            stream.removeTrack(track);
            try{
                track.stop();
                console.log('# video track stopped', track)
                // eslint-disable-next-line no-empty
            }catch(e){}
        });
    }
    static stopMediaStreamAudioTracks(stream) {
        if(!stream){
            return;
        }
        stream.getAudioTracks().forEach(track => {
            stream.removeTrack(track);
            try{
                if(track.readyState !== 'ended') {
                    track.stop();
                    console.log('# audio track stopped', track)
                }
                // eslint-disable-next-line no-empty
            }catch(e){}
        });
    }
    static async stopMediaStream(streams) {
        if(!streams){
            return;
        }

        if(streams instanceof Array == false){
            streams = [streams];
        }

        let tracks = [];
        streams.forEach(stream => {
            if(!stream) return;
            stream.getTracks().forEach(track => {
                stream.removeTrack(track);
                tracks.push(track);
            });
        });
        return this.stopMediaStreamTrack(tracks);
    }
    static async stopMediaStreamTrack(tracks) {
        if(tracks instanceof Array){
            return Promise.all(
                tracks.map(t => this.stopMediaStreamTrack(t))
            );
        }

        let track = tracks;
        if(track.readyState === 'ended'){
            return Promise.resolve();
        }

        try{
            track.stop();
            console.log('# stream track stopped', track)
        }catch(e){
            return Promise.reject(e);
        }

        return new Promise((resolve, reject) => {
            if(track.readyState === 'ended'){
                resolve();
                return;
            }
            track.addEventListener('ended', e => {
                resolve();
            }, {once: true});
        });
    }

    static setAudioTrackVolumeEvent(stream, callback){
        if(!stream || stream.getAudioTracks().length == 0){
            return null;
        }

        let requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame;


        let context = new AudioContext();

        let analyser = context.createAnalyser();
        analyser.fftSize = 1024;
        analyser.smoothingTimeConstant = 0.3;
        let dataArray = new Uint8Array(analyser.frequencyBinCount);

        let mediaStreamSource = context.createMediaStreamSource(stream);
        mediaStreamSource.connect(analyser);

        let track = stream.getAudioTracks()[0];
        let oldVolume = null;
        let volWarnCnt = 0;
        let updateAnalysers = function(){
            if(!track || track.readyState === 'ended'){
                return;
            }
            if(track.enabled){
                analyser.getByteFrequencyData(dataArray);

                let volume = 0, values = 0,
                    length = dataArray.length;
                for(let i=0; i<length; i++){
                    values += dataArray[i];
                }

                volume = values / length;

                if(oldVolume != volume){
                    callback({volume});
                    volWarnCnt = 0;
                }else if(volume > 0){
                    volWarnCnt++;
                    if(volWarnCnt > 50){
                        volWarnCnt = 0;
                        mediaStreamSource.disconnect(analyser);

                        context.close();
                        context = new AudioContext();
                        analyser = context.createAnalyser();
                        analyser.fftSize = 1024;
                        analyser.smoothingTimeConstant = 0.3;
                        dataArray = new Uint8Array(analyser.frequencyBinCount);
                        mediaStreamSource = context.createMediaStreamSource(stream);
                        mediaStreamSource.connect(analyser);
                        oldVolume = null;
                    }
                }
                oldVolume = volume;

                //requestAnimationFrame( updateAnalysers );
                setTimeout(updateAnalysers, 100);
            }else{
                setTimeout(updateAnalysers, 1000);
            }
        };
        requestAnimationFrame( updateAnalysers );
        //setTimeout(updateAnalysers, 100);
        //updateAnalysers();
    }

    static setAudioTrackVolumeEvent2(stream, callback){
        if(!stream || stream.getAudioTracks().length === 0){
            throw 'stream or audioTrack is null';
        }

        function SoundMeter(context, callback) {
            this.context = context;
            this.callback = callback;
            this.instant = 0.0;
            this.slow = 0.0;
            this.clip = 0.0;
            this.script = context.createScriptProcessor(2048, 1, 1);
            let prevInstant = 0;
            this.script.onaudioprocess = event => {
                const input = event.inputBuffer.getChannelData(0);
                let i;
                let sum = 0.0;
                let clipcount = 0;
                for (i = 0; i < input.length; ++i) {
                    sum += input[i] * input[i];
                    if (Math.abs(input[i]) > 0.99) {
                        clipcount += 1;
                    }
                }
                this.instant = Math.sqrt(sum / input.length);
                this.slow = 0.95 * this.slow + 0.05 * this.instant;
                this.clip = clipcount / input.length;

                const volume = soundMeter.instant * 100;
                if(prevInstant === volume){
                    return;
                }
                prevInstant = volume;

                if(volume < 1){
                    return;
                }
                this.callback && this.callback({
                    volume,
                    avgVolumeSecond: this.slow*100
                });
            };
        }

        Object.assign(SoundMeter.prototype, {
            connectToSource: function(stream) {
                // console.log('SoundMeter connecting');
                try {
                    this.mic = this.context.createMediaStreamSource(stream);
                    this.mic.connect(this.script);
                    // necessary to make sample run, but should not be.
                    this.script.connect(
                        this.context.destination
                        // this.context.createMediaStreamDestination()
                    );
                    // if (typeof this.callback !== 'undefined') {
                    //     this.callback(null);
                    // }
                } catch (e) {
                    console.error(e);
                    if (typeof this.callback !== 'undefined') {
                        this.callback({error:e});
                    }
                }
            },
            stop: function() {
                // console.log('SoundMeter stopping');
                this.mic.disconnect();
                this.script.disconnect();

                if(audioContext.state == 'running')
                    audioContext.close();            }
        })

        const AudioContext = window.AudioContext || window.webkitAudioContext;
        const audioContext = new AudioContext();
        const soundMeter = new SoundMeter(audioContext, callback);
        soundMeter.connectToSource(stream);

        {
            const track = stream.getAudioTracks()[0];
            track.addEventListener('_grm_atv_stop', e => {
                soundMeter.stop();
            });
            const _ori = track.stop;
            track.stop = function(){
                _ori.apply(track);
                track.dispatchEvent(new Event('_grm_atv_stop'));
            }
        }

        return soundMeter;
    }

    static async setAudioTrackVolumeEvent3(stream, callback){
        if(!stream || stream.getAudioTracks().length === 0){
            throw 'stream or audioTrack is null';
        }

        class SoundMeter {
            _init = false

            node
            mic
            context
            callback
            req = {
                id: 0,
                res: {}
            }

            constructor(context, callback) {
                this.context = context;
                this.callback = callback;
            }

            async init(){
                if(this._init) return;
                // if(!this.context._audioWorklet_module_atv){
                //     this.context._audioWorklet_module_atv = true;
                //     await this.context.audioWorklet.addModule(workletUrl)
                // }
                if(!this.context._audioWorklet_module_atv){
                    this.context._audioWorklet_module_atv = new Promise((r, c) => {
                        this.context.audioWorklet.addModule(workletUrl)
                            .then(r).catch(c)
                    });
                }
                await this.context._audioWorklet_module_atv;

                this.node = new AudioWorkletNode(this.context, 'volume-meter');
                this.node.port.onmessage = event => {
                    const msg = event.data;
                    if(msg.type === 'res'){
                        const req = this.req.res[msg.reqId];
                        if(req){
                            req.resolve(msg.data);
                        }
                    }else if(msg.api){
                        if(msg.api === 'onVolume'){
                            this.callback && this.callback({
                                prevVolume: msg.data.prevVolume,
                                volume: msg.data.volume,
                                avgVolumeSecond: msg.data.avgVolumeSecond
                            });
                        }
                    }
                };
                this._init = true
                return this
            }

            connectToSource(stream) {
                // console.log('SoundMeter connecting');
                try {
                    this.mic = this.context.createMediaStreamSource(stream);
                    this.mic.connect(this.node);
                    this.node.connect(
                        // this.context.destination
                        this.context.createMediaStreamDestination()
                    );
                } catch (e) {
                    console.error(e);
                    if (typeof this.callback !== 'undefined') {
                        this.callback({error: e});
                    }
                }
            }
            sendApi(api, data) {
                if(!this.node) throw 'not initialized';

                return new Promise((resolve, reject) => {
                    const req = {
                        reqId: ++this.req.id + '@' + Date.now(),
                        reqDate: Date.now(),
                        api,
                        data
                    };
                    this.req.res[req.reqId] = {
                        resolve, reject
                    }
                    this.node.port.postMessage(req);
                });
            }
            stop() {
                this.close();
            }
            close() {
                // console.log('SoundMeter stopping');
                this.mic?.disconnect();
                this.node?.disconnect();
                this.node?.port.close();
                this.context?.close();
                // if(this.context.state == 'running')
                //     this.context.close();
            }
        }

        const audioContext = await (async () => {
            // let ac = GrmWebRTC._audioWorklet_context;
            // if(ac && ac.state == 'running'){
            //     return ac;
            // }
            const AudioContext = window.AudioContext || window.webkitAudioContext;
            let ac = new AudioContext();
            if(ac.state === 'suspended'){
                try{
                    const list = ['mousedown', 'touchstart'];
                    list.forEach(type => {
                        document.addEventListener(type, async function listener(e){
                            if(ac.state === 'running') return;
                            list.forEach(type => document.removeEventListener(type, listener));
                            try{
                                await ac.resume();
                            }catch(e){
                                console.warn(e);
                            }
                        }, {once: true});
                    })
                }catch(e){
                    console.warn(e);
                }
            }
            return ac;
        })();
        let soundMeter;
        try {
            soundMeter = await new SoundMeter(audioContext, callback).init();
        }catch (e) {
            console.warn('Fail to use audioWorklet reason: ', workletUrl, e);
            return this.setAudioTrackVolumeEvent2(stream, callback);
        }

        soundMeter.connectToSource(stream);

        {
            const track = stream.getAudioTracks()[0];
            // track.addEventListener('_grm_atv_stop', e => {
            //     soundMeter.stop();
            // });
            const _ori = track.stop;
            track.addEventListener('ended', e => {
                soundMeter.close();
            });
            track.stop = function(){
                try{
                    _ori.apply(track);
                }finally{
                    // track.dispatchEvent(new Event('_grm_atv_stop'));
                    soundMeter.close();
                }
            }
        }

        return soundMeter;
    }

    static parseSenderRTCRtpEncodingParameters(params, config){
        if(!params.encodings || !params.encodings[0]){
            console.warn('parameter encodings is null', params.encodings);
            return;
        }

        const encoding = params.encodings[0];

        t:for(const key in config){
            const value = config[key];
            switch(key){
                case 'bitrate':
                case 'maxBitrate': {
                    let bitrate = value;
                    if(bitrate === 0 && browser?.name === 'safari'){
                        bitrate = 1;
                    }

                    if(bitrate === 'unlimited' || bitrate < 0){
                        delete encoding.maxBitrate;
                    }else{
                        let bw = parseInt(bitrate); // kb
                        if(isNaN(bw)){
                            throw ('wrong bandwidth value : ' + bitrate);
                        }
                        bitrate = bw;
                        if(encoding){
                            let b = bitrate * 1024;
                            if(encoding.maxBitrate === b){
                                break;
                            }
                            encoding.maxBitrate = b;
                        }else{
                            console.warn('params.encodings is empty');
                        }
                    }
                    break;
                }
                case 'framerate':
                case 'maxFramerate': {
                    let framerate = value;

                    if(framerate === null || framerate < 0){
                        delete encoding.maxFramerate;
                    }else{
                        framerate = parseInt(framerate);
                        if(isNaN(framerate)){
                            console.warn('wrong frameRate value :', framerate);
                            break;
                        }

                        if(encoding.maxFramerate === framerate){
                            break;
                        }
                        encoding.maxFramerate = framerate;
                    }
                    break;
                }
                case 'framerateBias': // 낮은 대역폭에서 프레임을 유지하려는 정도
                case 'qualityBias': // 낮은 대역폭에서 화질을 유지하려는 정도
                case 'priority': // 전송 우선순위: very-low, low, medium, high
                case 'contentHint': // 영상 타입: motion, detail, text (코덱 최적화?)
                case 'scaleResolutionDownBy': // scale 조절
                {
                    encoding[key] = value;
                    break;
                }
                case 'active': {
                    encoding[key] = value === true || value === 'true';
                    break;
                }
                case 'degradationPreference': // 품질저하방식: maintain-framerate, maintain-resolution, balanced
                {
                    params[key] = value;
                }
                default:
                    if(encoding[key] !== undefined){
                        encoding[key] = value;
                    }
                    break;
            }
        }

        if(config.active !== false){
            if(
              config.active !== true
              && encoding.maxBitrate !== undefined
              && encoding.maxBitrate !== null
              && encoding.maxBitrate < 1){
                encoding.active = false;
            }else{
                encoding.active = true;
            }
        }

        return params;
    }
    /////////////////////////////////////////////////////////////////////////////////////////////////
    #flag = {
        isSetLocalSdp: false,
        isSetRemoteSdp: false,
    };
    #reserveRemoteIceCandidateList = [];

    #event;
    #options;
    #pc;
    #pcNegoList = [];

    constructor(options = {}) {
        ID_NO++;
        Object.defineProperty(this, '_id', {value: ID_NO, writable: false});
        Object.defineProperty(this, '_createTime', {value: new Date(), writable: false});

        this.#options = _.merge({
            dataChannel: {
                bufferPoolingTimerMs: 0
            }
        }, options);

        this.#event = new GrmEvent();
        this.#event.runEvent();

        this.current = {
            bandWidth: {
                audio: {send: null, receive: null},
                video: {send: null, receive: null}
            }
        }
    }

    async close() {
        let pc = this.#pc;

        if(pc.iceConnectionState === 'closed'){
            return;
        }

        pc.close();

        this.#event.pushEvent({
            type: 'iceconnectionstatechange',
            target: this.#pc,
            data: {}
        });

        if(pc.iceConnectionState === 'closed'){
            return Promise.resolve();
        }
        return new Promise((resolve, reject) => {
            if(pc.iceConnectionState === 'closed'){
                resolve();
                return;
            }

            let evt = (e) => {
                let state = e.target.iceConnectionState;
                if(state !== 'closed'){
                    return;
                }
                this.removeEventListener('iceconnectionstatechange', evt);
                resolve();
            }
            this.addEventListener('iceconnectionstatechange', evt);
        });
    }

    isConnected(){
        return this.#pc && this.#pc.iceConnectionState === 'connected';
    }
    isClosed(){
        if(!this.#pc) return true;
        switch(this.#pc.iceConnectionState){
            case 'failed':
            case 'disconnected':
            case 'closed':
                return true;
        }
        return false;
    }
    isDisconnected(){
        if(!this.#pc) return true;
        switch(this.#pc.iceConnectionState){
            // case 'failed':
            case 'disconnected':
                return true;
        }
        return false;
    }

    async getCandidateType() {
        const pc = this.getPeerConnection();
        if(pc._candidateType){
            return pc._candidateType;
        }
        const stats = await pc.getStats();
        for (const report of stats.values()) {
            if (report.type !== "candidate-pair" || report.state !== "succeeded") {
                continue;
            }

            const localCandidate = stats.get(report.localCandidateId);
            // const remoteCandidate = stats.get(report.remoteCandidateId);

            if (localCandidate && localCandidate.relayProtocol) {
                pc._candidateType = 'relay';
                break;
            }
            pc._candidateType = localCandidate.candidateType;
            break;
        }
        return pc._candidateType;
    }

    async isRelayConnection(){
        const type = this.getCandidateType();
        return type === 'relay';
    }

    addEventListener(type, listener, options) {
        this.#event.addEventListener(type, listener, options);
        return this;
    }
    addOnceEventListener (type, listener, options) {
        options = options || {};
        options.once = true;
        this.addEventListener(type, listener, options);
        return this;
    }
    removeEventListener(type, listener) {
        this.#event.removeEventListener(type, listener);
        return this;
    }

    getSdpSemantics() {
        const peer = this.#pc;
        if(!peer.getConfiguration){
            return null;
        }
        let config = peer.getConfiguration();
        return config.sdpSemantics;
    }
    isUnifiedPlan() {
        let sm = this.getSdpSemantics();
        return sm === 'unified-plan'
            || (ChromeVersion >= 72 && sm !== 'plan-b')
            || SAFARI;
    }

    createPeerConnection(config={}, options={}) {
        let pcRtcConfig = {
            iceTransports: 'all', // relay,none
            // iceTransports -> iceTransportPolicy
            iceTransportPolicy: 'all', // relay,none
            iceTransportType: 'all',
            bundlePolicy: 'balanced',
            //rtcpMuxPolicy: 'negotiate',
            iceServers: [
                {'url': 'stun:stun.l.google.com:19302'},
                // {'url': 'stun:biz-turn.gooroomee.com:443'},
            ],
        };

        ['iceTransports', 'iceTransportPolicy'].forEach(key => {
            if(options[key]){
                pcRtcConfig[key] = options[key];
            }
        })

        if(ChromeVersion >= 59){
            if(options.iceCandidatePoolSize !== undefined){
                pcRtcConfig.iceCandidatePoolSize = options.iceCandidatePoolSize;
            }
        }
        if(ChromeVersion >= 72 && options.sdpSemantics){
            pcRtcConfig.sdpSemantics = options.sdpSemantics;
        }

        Object.assign(pcRtcConfig, config);

        if(options.iceServers && options.iceServers.length > 0) {
            pcRtcConfig.iceServers = options.iceServers;
        }

        const pc = this.#pc = new RTCPeerConnection(pcRtcConfig);
        this._pc_id = this._pc_id || 1;
        Object.defineProperty(pc, '_id', {
            value: this._id + '-' + (this._pc_id++),
            writable: false
        });
        Object.defineProperty(pc, '_createTime', {value: new Date(), writable: false});

        const events = {
            icecandidate: function(e){
                if(e.candidate){
                    this.#event.pushEvent(e);
                }else{
                    this.#event.pushEvent({
                        type: 'icecandidatecomplete',
                        target: pc,
                        data: {}
                    });
                }
            },
            iceconnectionstatechange: function(e){
                const pc = e.target;
                const state = pc.iceConnectionState;
                if(state !== 'connected'){
                    delete pc._candidateType;
                }

                switch (state) {
                    case 'completed':
                        break;
                    case 'connected':
                        if(pc.disconnectedTime){
                            let term = pc.disconnectedTime - pc._connectedTime;
                            console.warn('GrmWebRTC reconnected : %dms', term);

                            try{
                                this.#pc.getRemoteStreams().forEach(stream => {
                                    e.stream = stream;
                                    this.#event.pushEvent('addstream', e);
                                });
                            }catch(e){
                                console.error(e);
                            }
                        }

                        pc._connectedTime = Date.now();
                        this.getCandidateType();
                        break;
                    case 'disconnected':
                        // console.debug('CsWebRTC RTP ports are closed. UDP connection is dropped.');
                        pc._disconnectedTime = Date.now();

                        if(this.#pcNegoList.length > 0){
                            console.log('#[grm-webrtc] conn is dropped - clear job : ${this.#pcNegoList.length}');
                            this.#pcNegoList = [];
                        }
                        break;
                }

                this.#event.pushEvent(e);
            },
            negotiationneeded: function(e){
                this.#event.pushEvent(e);
            },
            signalingstatechange: function(e){
                this.#event.pushEvent(e);

                let state = e.target.signalingState;
                if(state === 'stable'){
                    let job = this.#pcNegoList.shift();
                    if(job){
                        job();
                    }
                }
            },
            track: function(e){
                this.#event.pushEvent(e);
            },
            removetrack: function(e){
                this.#event.pushEvent(e);
            },
            addstream: function(e){
                this.#event.pushEvent(e);
            },
            removestream: function(e){
                this.#event.pushEvent(e);
            },
            datachannel: function(e){
                const channel = e.channel;
                this._setDataChannel(channel);

                // 바로 발생해서 여러 로직이 수행될 경우 모바일과의 통신에서 행이 걸리는 케이스가 있음
                this.#event.pushEvent(e);
            },
        };

        ['connecting', 'open'].forEach(type => {
            this.#pc.addEventListener(type, e => {
                this.#event.pushEvent(e);
            });
        });
        for(let type in events){
            this.#pc.addEventListener(type, events[type].bind(this))
        }

        return this;
    }

    getPeerConnection() {
        return this.#pc;
    }

    addTrack (track) {
        const pc = this.getPeerConnection();
        const sender = pc.addTrack(track);

        const list = pc.getTransceivers().filter(trans => {
            let t = trans.sender.track || trans.receiver.track;
            if(!t) return false;
            return t.kind === track.kind;
        });
        const idx = list.findIndex(t => t.sender===sender);
        const trans = list[idx];
        this.#event.pushEvent({
            type: 'addTransceiver',
            target: pc,
            transceiver: trans,
            kind: track.kind,
            index: idx
        });
        return trans;
    }

    getTransceivers () {
        const pc = this.getPeerConnection();
        return pc.getTransceivers();
    }
    addTransceiver (kind, options) {
        if(!options){
            options = {direction: 'sendrecv'}
        }else if(typeof options === 'string'){
            options = {direction: options};
        }

        const pc = this.getPeerConnection();
        const trans = pc.addTransceiver(kind, options);

        const list = pc.getTransceivers().filter(t => {
            let track = t.sender.track || t.receiver.track;
            if(!track) return false;
            return track.kind === kind;
        });
        const idx = list.findIndex(t => t===trans);
        this.#event.pushEvent({
            type: 'addTransceiver',
            target: pc,
            transceiver: trans,
            kind,
            index: idx
        });
        return trans;
    }
    addTransceivers (arr) {
        return arr.map(params => {
            if(typeof params === 'string'){ // kind
                return this.addTransceiver(params);
            }else{
                return this.addTransceiver(params.kind, params.options);
            }
        });
    }

    _setDataChannel(channel) {
        let act=false, queue=[], timer;

        let execute = (chk) => {
            if(chk && act){
                return;
            }
            if(queue.length === 0){
                return;
            }
            if(channel.readyState !== 'open'){
                // console.log('channel.readyState :', channel.readyState);
                act = false;
                queue = [];
                return;
            }

            if(channel.bufferedAmount === 0){
                let data = queue.shift();
                if(!data){
                    act = false;
                    return;
                }
                channel.send(data);
                if(queue.length === 0){
                    act = false;
                    return;
                }
            }

            act = true;
            clearTimeout(timer);
            timer = setTimeout(() => {
                execute();
            }, this.#options.dataChannel?.bufferPoolingTimerMs || 10);
            // channel.addEventListener('bufferedamountlow', (e) => {
            //     console.log("Buffer is low, you can send more data.");
            // }, {once: true});
        }

        channel.sendQueue = function(data){
            queue.push(data);
            execute(true);
        }
        channel.clearSendQueue = function(){
            queue.length = 0;
        }
        channel.getSendQueueSize = function(){
            return queue.length;
        }
        return channel;
    }

    createDataChannel(label, options={}) {
        if(!label){
            label = 'CsWebRTC';
        }

        let config = Object.assign({}, options);
        let channel = this.#pc.createDataChannel(label, config);
        this.#pc.dispatchEvent(
            new RTCDataChannelEvent('datachannel', {
                self: true,
                channel
            })
        );
        // this._setDataChannel(channel);
        // this.#event.pushEvent({
        //     type: 'datachannel',
        //     self: true,
        //     channel
        // });
        return channel;
    }

    // 설정하고 offer/answer 필요.
    setVideoCodec({transceiver, mid, track, mimeTypes, sdpFmtpLine}){
        let trans = transceiver;
        if(!trans){
            if(!mimeTypes) return;
            if(!track) return;
            trans = this.getTransceiverByMid(mid) || this.getTransceiverByTrack(track);
        }
        if(!trans){
            console.warn('transceiver is null : mid[%s]', mid, track);
            return [];
        }

        const {codecs} = RTCRtpSender.getCapabilities('video');
        // let selectedCodecIndex = codecs.findIndex(c => c.mimeType === mimeType && (!sdpFmtpLine || c.sdpFmtpLine === sdpFmtpLine));
        // if(selectedCodecIndex < 0){
        //     selectedCodecIndex = codecs.findIndex(c => c.mimeType === mimeType);
        //     if(selectedCodecIndex < 0){
        //         console.warn('not supported codec : mimeType[%s], sdpFmtpLine[%s]', mimeType, sdpFmtpLine);
        //         return;
        //     }
        //     console.log('not supported codec sdpFmtpLine : mimeType[%s], sdpFmtpLine[%s] -> sdpFmtpLine[%s]',
        //         mimeType, sdpFmtpLine, codecs[selectedCodecIndex].sdpFmtpLine);
        // }

        if(!Array.isArray(mimeTypes)){
            mimeTypes = [mimeTypes];
        }

        const findCodecs = [];
        mimeTypes.forEach(mimeType => {
            while(true){
                let selectedCodecIndex = codecs.findIndex(c => {
                    return c.mimeType === mimeType
                      && (!sdpFmtpLine || c.sdpFmtpLine === sdpFmtpLine);
                });
                if(selectedCodecIndex < 0){
                    break;
                }
                findCodecs.push(
                  codecs.splice(selectedCodecIndex, 1)[0]
                );
            }
        });
        // findCodecs.reverse().forEach(c => {
        //     codecs.unshift(c);
        // });
        if(findCodecs.length === 0){
            return findCodecs;
        }

        let srcCodecs = findCodecs.concat(codecs);
        while(srcCodecs.length > 0){
            try{
                trans.setCodecPreferences(srcCodecs);
                break;
            }catch(e){
                srcCodecs.pop();
            }
        }
        return srcCodecs;
        // try{
        //     let cds = findCodecs.concat(codecs);
        //     trans.setCodecPreferences(cds);
        //     return cds;
        // }catch(e){
        //     try{
        //         trans.setCodecPreferences(findCodecs);
        //         return findCodecs;
        //     }catch(e){
        //         console.warn(e);
        //         return [];
        //     }
        // }
    }

    async createOffer(options={}) {
        let pc = this.#pc;

        let config = this.isUnifiedPlan() ? options : Object.assign({
            offerToReceiveAudio: true,
            offerToReceiveVideo: true
        }, options);

        let localSdp = await pc.createOffer(config);
        // let bw = setBandWidth(this, localSdp.sdp, this.#options);
        // localSdp.sdp = bw.sdp;

        // this.current.bandWidth.audio.receive = bw.audio || 'auto';
        // this.current.bandWidth.video.receive = bw.video || 'auto';

        changeSdpCodec(localSdp, options)

        return localSdp;
    }
    async createAnswer(remoteSdp, options={}) {
        let pc = this.#pc;

        if(!this.isStable()){
            const jobId = Date.now();
            console.log(`# grm-webrtc add job : ${jobId}`);
            let args = arguments;
            return new Promise((resolve, reject) => {
                this.#pcNegoList.push((function(){
                    console.log(`# grm-webrtc run job : ${jobId}`);
                    this.createAnswer.apply(this, args)
                        .then(resolve)
                        .catch(reject);
                }).bind(this));
            });
        }

        // let bw = setBandWidth(this, remoteSdp.sdp, this.#options);
        // remoteSdp.sdp = bw.sdp;

        // this.current.bandWidth.audio.send = bw.audio || 'auto';
        // this.current.bandWidth.video.send = bw.video || 'auto';

        await this.setRemoteDescription(new RTCSessionDescription(remoteSdp));
        let localSdp = await pc.createAnswer();
        changeSdpCodec(localSdp, options);

        return localSdp;
    }
    async setLocalDescription(sdp) {
        let pc = this.#pc;
        await pc.setLocalDescription(sdp);

        return pc.localDescription;
    }

    async setRemoteDescription(sdp) {
        let pc = this.#pc;
        await pc.setRemoteDescription(sdp);

        if(!this.#flag.isSetRemoteSdp){
            this.#flag.isSetRemoteSdp = true;

            if(this.#reserveRemoteIceCandidateList.length > 0){
                this.#reserveRemoteIceCandidateList.forEach(icecandidate => {
                    this.addIceCandidate(icecandidate);
                });
                this.#reserveRemoteIceCandidateList = [];
            }
        }
    }

    async addIceCandidate(icecandidate){
        if(!this.#flag.isSetRemoteSdp){
            this.#reserveRemoteIceCandidateList.push(icecandidate);
            return;
        }

        return this.#pc.addIceCandidate(new RTCIceCandidate(icecandidate));
    }

    addStream(stream) {
        if(!stream){
            return false;
        }

        const peer = this.#pc;
        if(this.isUnifiedPlan()){
            if(peer.addTrack !== undefined){
                stream.getTracks().forEach(t => {
                    try{
                        let exists = peer.getSenders().find(s => s.track === t);
                        if(!exists){
                            peer.addTrack(t, stream);
                        }
                    }catch(e){
                        console.warn(e);
                    }
                })
            }else{
                peer.addStream(stream);
            }
        }else{
            if(peer.getLocalStreams().includes(stream)){
                return true;
            }
            peer.addStream(stream);
        }
        return true;
    }

    removeStream(stream) {
        if (!stream){
            return false;
        }

        const peer = this.#pc;
        if(this.isUnifiedPlan()){
            if(peer.removeTrack !== undefined){
                stream.getTracks().forEach(t => {
                    let sender = peer.getSenders().find(s => s.track === t);
                    if(!sender) return;

                    try{
                        peer.removeTrack(sender);
                    }catch(e){
                        console.warn(e);
                    }
                })
            }else{
                peer.removeStream(stream);
            }
        }else{
            peer.removeStream(stream);
        }
        return true;
    }

    hasTransceiverByMid(mid){
        return !!this.getTransceiverByMid(mid);
    }
    getTransceiverByMid(mid){
        if(!mid) return;
        const pc = this.#pc;
        const trans = pc.getTransceivers().find(t => t.mid == mid);
        return trans;
    }

    getTransceiverByKind(kind, no){
        let trans = this.getTransceiverBySenderKind(kind, no);
        if(!trans){
            trans = this.getTransceiverByReceiverKind(kind, no);
        }
        return trans;
    }
    getTransceiverBySenderKind(kind, no){
        const pc = this.getPeerConnection();
        const trans = pc.getTransceivers().filter(t => {
            return t.sender?.track?.kind === kind;
        })[no || 0];
        return trans;
    }
    getTransceiverByReceiverKind(kind, no){
        const pc = this.getPeerConnection();
        const trans = pc.getTransceivers().filter(t => {
            return t.receiver?.track?.kind === kind;
        })[no || 0];
        return trans;
    }

    getTransceiverByTrack(track){
        if(!track) return;
        const pc = this.#pc;
        const trans = pc.getTransceivers().find(t => {
            return t.sender?.track === track || t.receiver?.track === track;
        });
        return trans;
    }

    async replaceTrackByTransceiver(trans, track){
        if(!trans) {
            console.warn('transceiver is null :', trans ,track);
            return;
        }

        // inactive, sendonly, recvonly, sendrecv
        if(trans.direction !== 'sendonly' && trans.direction !== 'sendrecv'){
            trans.direction = 'sendrecv';
        }
        if(trans.sender.track === track){
            // console.warn('transceiver.sender track already :', track);
            return;
        }
        return trans.sender.replaceTrack(track);
    }

    async replaceTrackBySenderTrack(findTrack, replaceTrack){
        if(!findTrack){
            console.warn('replaceTrackBySenderTrack wrong parameters :', findTrack);
            return;
        }

        let trans = this.getTransceiverByTrack(findTrack);
        if(!trans) {
            console.warn('transceiver is null :', findTrack);
            return;
        }

        return this.replaceTrackByTransceiver(trans, replaceTrack);
    }

    async replaceTrackByMid(mid, track){
        if(mid === undefined || mid === null){
            console.warn('replaceTrackByMid wrong parameters :', mid);
            return;
        }

        let trans = this.getTransceiverByMid(mid);
        if(!trans) {
            console.warn('transceiver is null :', mid ,track);
            return;
        }

        return this.replaceTrackByTransceiver(trans, track);
    }

    async replaceFirstAudioSenderTrack(track, defaultMid){
        let trans = this.getTransceiverByKind('audio', 0);
        if(!trans && defaultMid !== undefined && defaultMid != null){
            trans = this.getTransceiverByMid(defaultMid);
        }
        return this.replaceTrackByTransceiver(trans, track);
    }

    async replaceFirstVideoSenderTrack(track, defaultMid){
        let trans = this.getTransceiverByKind('video', 0);
        if(!trans){
            trans = this.getTransceiverByMid(defaultMid);
        }
        return this.replaceTrackByTransceiver(trans, track);
    }

    isStable() {
        return this.#pc && this.#pc.signalingState === 'stable';
    }

    async changeSenderRTCRtpEncodingParameters(sender, chParams){
        if(!sender || !chParams){
            return;
        }

        // parse sender
        if(typeof sender === 'string'){
            const trans = this.getTransceiverByMid(sender);
            if(!trans){
                return;
            }
            sender = trans.sender;
        }else if(sender instanceof MediaStreamTrack){
            const trans = this.getTransceiverByTrack(sender);
            if(!trans){
                return;
            }
            sender = trans.sender;
        }

        // job already
        if(sender._setParams_job){
            sender._setParams_q = sender._setParams_q || [];
            return new Promise((resolve, reject) => {
                const id = Date.now();
                sender._setParams_q.push({
                    id, sender, chParams,
                    resolve, reject
                });
            });
        }

        let parameters = sender.getParameters();
        GrmWebRTC.parseSenderRTCRtpEncodingParameters(parameters, chParams);
        try{
            await sender.setParameters(parameters);
            // console.log('@@@@', chParams, parameters.encodings[0], sender.getParameters().encodings[0])
        }catch(e){
            console.error('set sender params fail', sender, chParams, e);
            throw e;
        }finally{
            sender._setParams_job = null;
            if(!sender._setParams_q || sender._setParams_q.length == 0) return;
            let job = sender._setParams_q.shift();
            // console.trace('@@@@@@ next job :', job.id);
            return this.changeSenderRTCRtpEncodingParameters(job.sender, job.chParams)
                .then(job.resolve)
                .catch(job.reject);
        }
    }

    async changeSenderRTCRtpEncodingParametersByFilter(filter, params) {
        if(ChromeVersion < 72 || !this.#pc.getSenders){
            return Promise.reject('not supported');
        }
        const jobs = this.#pc.getSenders().filter(filter).map(s => {
            return this.changeSenderRTCRtpEncodingParameters(s, params);
        });
        await Promise.all(jobs);
    }

    async getBandwidthByStatsObject(statsObj, key){
        const get = async () => {
            let stats = await statsObj.getStats();
            let result = stats.values().find(v => v.id.startsWith(
                // 'RTCIceCandidatePair_'
                key || 'RTCIceCandidatePair_'
            ));
            return result;
        }

        const b1 = await get();
        return new Promise((resolve, reject) => {
            setTimeout(async () => {
                const b2 = await get();
                const result = {};
                ['bytesSent', 'bytesReceived'].forEach(k => {
                    result[k] = b2[k] - b1[k];
                });
                resolve(result);
            }, 1000);
        });
    }

    async getCandidateState () {
        const pc = this.getPeerConnection();
        if(!pc) return false;
        const stats = await pc.getStats();
        const result = {
            connected: pc.iceConnectionState === "connected"
        };
        stats.forEach(report => {
            if (
              report.type === 'candidate-pair' // ICE candidate pair 확인
              && report.state === 'succeeded' // 활성화된 candidate pair
              // && report.selectedCandidatePairId // 선택된 candidate pair인지 확인
            ) {
                ['local', 'remote'].forEach(nt => {
                    const stat = stats.get(report[nt+'CandidateId']);
                    if(!stat) return;
                    result[nt] = Object.assign({
                        isRelay: function(){
                            return this.candidateType === 'relay';
                        }
                    }, stat);
                })
            }
        });
        return result;
    }

    async getCodecInfo () {
        const peerConnection = this.getPeerConnection();
        const stats = await peerConnection.getStats();

        const sendingCodecs = [];
        const receivingCodecs = [];
        const codecs = new Map();

        // 모든 codec 정보
        stats.forEach(report => {
            if (report.type === 'codec') {
                const value = {
                    mimeType: report.mimeType,
                    payloadType: report.payloadType,
                    clockRate: report.clockRate,
                    sdpFmtpLine: report.sdpFmtpLine || 'N/A'
                };
                if(report.channels){
                    value.channels = report.channels;
                }
                codecs.set(report.id, value);
            }
        });

        // 보내는 track
        stats.forEach(report => {
            if (report.type !== 'outbound-rtp') return;
            const codec = codecs.get(report.codecId);
            if (!codec) return;
            const track = this.getTransceiverByMid(report.mid)?.receiver?.track;
            if(!track) return;

            sendingCodecs.push({
                trackId: track.id,
                kind: report.kind,
                mid: report.mid,
                ...codec
            });
        });

        // 받는 track
        stats.forEach(report => {
            if (report.type !== 'inbound-rtp')  return;
            const codec = codecs.get(report.codecId);
            if (!codec) return;
            const track = this.getTransceiverByMid(report.mid)?.receiver?.track;
            if(!track) return;

            receivingCodecs.push({
                trackId: track.id,
                kind: report.kind,
                mid: report.mid,
                ...codec
            });
        });

        return { send: sendingCodecs, receive: receivingCodecs };
    }

    async getBandwidthByTrack(track){
        const peer = this.getPeerConnection();
        const obj = {
            getStats: () => {
                peer.getStats(track);
            }
        };
        const bw = await this.getBandwidthByStatsObject(obj);
        return bw;
    }

    async getReceiveBandwidthByMid(mid){
        const trans = this.getTransceiverByMid(mid);
        if(!trans){
            return Promise.reject('transiver not found');
        }
        const bw = await this.getBandwidthByStatsObject(trans.receiver, 'RTCInboundRTP');
        return bw.bytesReceived;
    }

    async getSendBandwidthByMid(mid){
        const trans = this.getTransceiverByMid(mid);
        if(!trans){
            return Promise.reject('transiver not found');
        }
        const bw = await this.getBandwidthByStatsObject(trans.sender, 'RTCOutboundRTP');
        return bw.bytesSent;
    }

    static getStreamId(options) {
        if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
            let constraints = {
                video: {
                    frameRate: 15,
                },
                audio: {
                    echoCancellation: true,
                    noiseSuppression: true,
                    sampleRate: 44100
                }
            };

            if(options.constraints.video){
                Object.assign(
                    constraints.video,
                    options.constraints.video.mandatory || options.constraints.video
                );
            }

            if(options.constraints.audio){
                Object.assign(constraints.audio, options.constraints.audio);
            }

            return navigator.mediaDevices.getDisplayMedia(constraints)
                .then(stream => {
                    return {stream};
                })
                .catch(e => { throw e;})
        }
    }
    restartIce() {
        if(!this.#pc) return
        this.#pc.restartIce()
    }
}

// private //////////////////////
function changeSdpCodec(sdp, options){
    ['audio', 'video'].forEach(c => {
        let codec = options.codec && options.codec[c];
        if(codec){
            sdp.sdp = _changeSdpCodec(sdp.sdp, c, codec.toUpperCase());
        }
    });
}
function _changeSdpCodec(sdp, media, codec){
    let idx_ed = sdp.indexOf(codec + '/');
    if(idx_ed < 0){
        return sdp;
    }

    let idx_st = sdp.lastIndexOf('\r\n', idx_ed);
    let codecNo = sdp.substring(idx_st, idx_ed).replace('a=rtpmap:', '').trim();
    if(!codecNo){
        console.warn('change %s codec fail 1:', media, codec);
        return sdp;
    }

    let codecsStr = this.getMediaSdpLine(media, sdp);
    let list = codecsStr.split(' ');
    let ori = list[3];
    if(ori == codecNo){
        return sdp;
    }

    let codecIdx = list.indexOf(codecNo);
    if(codecIdx > -1){
        list[3] = list[codecIdx];
        list[codecIdx] = ori;

        sdp = sdp.replace(codecsStr, list.join(' '));
    }else{
        console.warn('change %s codec fail 2:', media, codec);
    }

    return sdp;
}

class SerializeRequest {
    constructor() {
        this.queue = [];
    }

    request(req){
        const queue = this.queue;
        const promise = new Promise((resolve, reject) => {
            queue.push({
                req, resolve, reject
            });
            
            if(queue.length === 1){
                let run = async (queue) => {
                    const job = queue[0];
                    if(!job) return;
                    return job.req()
                        .then(job.resolve)
                        .catch(job.reject)
                        .finally(() => {
                            queue.shift();
                            run(queue);
                        })
                }
                run(queue)
                    .catch(e => {
                        console.warn(e);
                    });
            }
        });
        return promise;
    }
}
const SR = new SerializeRequest();